var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { ref: "pad", staticClass: "pad" }, [
    _c(
      "div",
      { staticClass: "virtual-keypad" },
      _vm._l(_vm.numbers, function (number) {
        return _c(
          "button",
          {
            key: number,
            class: { clear: number === "C" },
            on: {
              click: function ($event) {
                _vm.handleKeyPress(number), $event.target.blur()
              },
            },
          },
          [_vm._v(_vm._s(number))]
        )
      }),
      0
    ),
    _c("div", { staticClass: "extra-buttons" }, [
      _c("div", { staticClass: "b-p" }, [_vm._v(_vm._s(_vm.value))]),
      _c(
        "button",
        {
          on: {
            click: function ($event) {
              _vm.changeTotal(), $event.target.blur()
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("components.sales.Cashier.keypad.quantity")))]
      ),
      _c(
        "button",
        {
          on: {
            click: function ($event) {
              _vm.retour(), $event.target.blur()
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("components.sales.Cashier.keypad.return")))]
      ),
      _c(
        "button",
        {
          on: {
            click: function ($event) {
              _vm.remove(), $event.target.blur()
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("components.sales.Cashier.keypad.clear")))]
      ),
    ]),
    _c("div", { staticClass: "extra-buttons ml" }, [
      _c(
        "button",
        {
          on: {
            click: function ($event) {
              _vm.state.mergeSaleRows(), $event.target.blur()
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("components.sales.Cashier.keypad.group")))]
      ),
      _c(
        "button",
        {
          class: {
            discount:
              _vm.state.selectedRow && _vm.state.selectedRow?.Discount !== 0,
          },
          on: {
            click: function ($event) {
              _vm.discount(), $event.target.blur()
            },
          },
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm.$t("components.sales.Cashier.keypad.discount")) +
              " "
          ),
        ]
      ),
      _c(
        "button",
        {
          on: {
            click: function ($event) {
              _vm.price(), $event.target.blur()
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("components.sales.Cashier.keypad.price")))]
      ),
      _c(
        "button",
        {
          on: {
            click: function ($event) {
              _vm.diverse(), $event.target.blur()
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("components.sales.Cashier.keypad.diverse")))]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }